import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule,
         MatTabsModule,
         MatButtonToggleModule,
         MatTableModule,
         MatDividerModule,
         MatIconModule,
         MatTooltipModule,
         MatFormFieldModule,
         MatAutocompleteModule,
         MatInputModule,
         MatDialogModule
} from '@angular/material';
import 'hammerjs';

import { AppComponent } from './app.component';
import { LoanTableComponent } from './loan-table/loan-table.component';

import { CustomAmountEditorComponent } from './loan-table/custom-amount-editor/custom-amount-editor.component';
import { CustomInterestRateEditorComponent } from './loan-table/custom-interest-rate-editor/custom-interest-rate-editor.component';
import { CustomAutoTextEditorComponent } from './loan-table/custom-auto-text-editor/custom-auto-text-editor.component';
import { CustomButtonEditorComponent } from './loan-table/custom-button-editor/custom-button-editor.component';
import { ValidationDialogComponent } from './loan-table/validation-dialog/validation-dialog.component';
import {CustomYearEditorComponent} from './loan-table/custom-year-editor/custom-year-editor.component';
import {MatSliderModule} from '@angular/material/slider';

@NgModule({
  declarations: [
    AppComponent,
    LoanTableComponent,
    CustomAmountEditorComponent,
    CustomInterestRateEditorComponent,
    CustomAutoTextEditorComponent,
    CustomButtonEditorComponent,
    CustomYearEditorComponent,
    ValidationDialogComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    Ng2SmartTableModule,
    HighchartsChartModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatTableModule,
    MatDividerModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSliderModule,

  ],
  entryComponents: [
    CustomAmountEditorComponent,
    CustomInterestRateEditorComponent,
    CustomAutoTextEditorComponent,
    CustomButtonEditorComponent,
    CustomYearEditorComponent,
    ValidationDialogComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
